/* Minvelle Cart v2 */
(function () {
  'use strict';
  // ponytail: one BCP-47 map for all five storefront languages. Was `lang === 'de' ? 'de-AT' :
  // 'en-US'` in five places, which formatted Spanish, French and Italian carts as en-US: dot
  // decimals and month/day dates in countries that use neither.
  const MV_LOCALES = { en: 'en-US', de: 'de-AT', es: 'es-ES', fr: 'fr-FR', it: 'it-IT' };
  const mvLocale = () => MV_LOCALES[(document.documentElement.lang || 'en').slice(0, 2)] || 'en-US';

  const FREE_SHIPPING_THRESHOLD_CENTS = 2900;
  const BELOW_THRESHOLD_RATE_CENTS = 399;
  const SUB_PLAN_ID = 692093845850;
  const VARIANT_1BOX = 53814535455066;
  const VARIANT_2BOX = 53814535487834;
  const VARIANT_6BOX = 53814535520602;
  const VARIANT_4BOX = 54490499416410;

  const t = (k) => fxStr((window.MinvelleCartStrings || {})[k] || k);
  // ponytail: format in the cart's real presentment currency (US visitors get USD, not a hardcoded €)
  let _moneyFmt = null, _cartCurrency = '';
  function setCurrency(cur){
    cur = cur || 'EUR';
    if (_moneyFmt && cur === _cartCurrency) return;
    _cartCurrency = cur;
    const lang = (document.documentElement.lang || 'en').slice(0, 2);
    try { _moneyFmt = new Intl.NumberFormat(mvLocale(), { style: 'currency', currency: cur }); }
    catch (e) { _moneyFmt = null; }
    if (cur !== 'EUR') document.documentElement.setAttribute('data-mv-currency', cur);
    else document.documentElement.removeAttribute('data-mv-currency');
  }
  const fmtMoney = (c) => {
    if (_moneyFmt) return _moneyFmt.format(c / 100);
    // Intl unavailable: en/de put the symbol first, es/fr/it put it last.
    const lg = (document.documentElement.lang || 'en').slice(0, 2);
    const n = (c / 100).toFixed(2).replace('.', lg === 'en' ? '.' : ',');
    return (lg === 'es' || lg === 'fr' || lg === 'it') ? n + ' €' : '€' + n;
  };

  // ponytail: EUR literals shown to non-EUR sessions get converted with the Markets FX rate; EUR sessions are untouched
  function fxRate(){
    const cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (!cur || cur === 'EUR') return null;
    const fx = parseFloat(window.Shopify.currency.rate);
    if (!fx || !isFinite(fx)) return null;
    return { cur, fx };
  }
  // Checkout rounds converted charges UP to the whole unit (observed: EUR 39.99 -> USD 47.00).
  // Mirror it so the LP never shows a lower number than checkout charges:
  // whole-unit ceil for price-sized amounts, next-10-cents ceil for small derived ones (per-day/per-piece).
  function ceilFxUnit(v){ return v >= 10 ? Math.ceil(v) : Math.ceil(v * 10) / 10; }
  function fmtFx(eurCents, r, opts){
    opts = opts || {};
    const lang = (document.documentElement.lang || 'en').slice(0, 2);
    const loc = opts.locale || mvLocale();
    const v = eurCents * r.fx / 100;
    const rounded = ceilFxUnit(v);
    try {
      if (v >= 10) return new Intl.NumberFormat(loc, { style: 'currency', currency: r.cur, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(rounded);
      return new Intl.NumberFormat(loc, { style: 'currency', currency: r.cur }).format(rounded);
    } catch (e) { return null; }
  }
  // 2026-10-24 CRO: derived figures (per box, savings, compare-at) come from the converted + rounded PRICES, the way
  // the cart charges them, instead of converting and ceiling each EUR figure on its own (USD showed "Save $12" and
  // "$18 per box" for a real $11 and $17.50). data-mv-fx="[k*]A[-[k*]B][/n]", A and B = EUR cents of real prices.
  function fxDerived(f, r){
    const m = /^(?:(\d+)\*)?(\d+)(?:-(?:(\d+)\*)?(\d+))?(?:\/(\d+))?$/.exec(f || '');
    if (!m) return null;
    const P = (c) => ceilFxUnit(c * r.fx / 100);
    const v = ((+(m[1] || 1)) * P(+m[2]) - (m[4] ? (+(m[3] || 1)) * P(+m[4]) : 0)) / (+(m[5] || 1));
    const c = Math.round(v * 100), d = c % 100 === 0 ? 0 : 2;
    try { return new Intl.NumberFormat(mvLocale(), { style: 'currency', currency: r.cur, minimumFractionDigits: d, maximumFractionDigits: d }).format(c / 100); }
    catch (e) { return null; }
  }
  window.mvFx = (f) => { const r = fxRate(); return r ? fxDerived(String(f), r) : null; };
  // Rewrites "€NN" / "€NN.NN" / "NN,NN €" tokens inside a localized string; whole-EUR amounts round to whole units.
  function fxStr(s){
    const r = fxRate();
    if (!r || typeof s !== 'string' || s.indexOf('\u20ac') === -1) return s;
    return s.replace(/\u20ac\s?(\d+(?:[.,]\d{2})?)|(\d+(?:[.,]\d{2})?)\s?\u20ac/g, (m, a, b) => {
      const num = a || b;
      const whole = !/[.,]/.test(num);
      const out = fmtFx(Math.round(parseFloat(num.replace(',', '.')) * 100), r, { whole });
      return out === null ? m : out;
    });
  }
  // Static markup tagged with data-mv-eur-cents gets rewritten in place for non-EUR sessions.
  function convertTagged(){
    const r = fxRate();
    if (!r) return;
    document.querySelectorAll('.mv-eur-only').forEach((el) => { el.hidden = true; }); // e.g. "(25%)": true in EUR only
    document.querySelectorAll('[data-mv-eur-cents]').forEach((el) => {
      const cents = parseInt(el.getAttribute('data-mv-eur-cents'), 10);
      if (!cents) return;
      const scope = el.closest('[lang]');
      const lang = scope ? (scope.getAttribute('lang') || '').slice(0, 2) : '';
      const f = el.getAttribute('data-mv-fx');
      const out = f ? fxDerived(f, r) : fmtFx(cents, r, { locale: mvLocale() });
      if (out !== null) el.textContent = out;
    });
  }


  // ponytail: EUR shipping constants converted to cart currency via Shopify Markets FX rate; null = rate unknown, hide the bar instead of lying
  function shipConsts(cur){
    if (!cur || cur === 'EUR') return { threshold: FREE_SHIPPING_THRESHOLD_CENTS, displayThreshold: FREE_SHIPPING_THRESHOLD_CENTS, cost: BELOW_THRESHOLD_RATE_CENTS };
    const fx = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    if (!fx || !isFinite(fx)) return null;
    // displayThreshold mirrors the nudge copy's ceiled value (same ceilFxUnit rule) so the progress
    // bar never shows a different "free shipping over X" number than the nudge text. Unlock still
    // fires at the raw `threshold` below it, so the bar can flip to unlocked slightly before it
    // visually reaches the displayed target — harmless, feels early not late.
    return {
      threshold: Math.round(FREE_SHIPPING_THRESHOLD_CENTS * fx),
      displayThreshold: Math.round(ceilFxUnit(FREE_SHIPPING_THRESHOLD_CENTS * fx / 100) * 100),
      cost: Math.round(BELOW_THRESHOLD_RATE_CENTS * fx)
    };
  }

  const state = { cart: null, open: false };
  let elRoot, elBackdrop;

  // Device + browser detection for express-wallet filtering
  const _ua = navigator.userAgent;
  const _isIOS = /iPad|iPhone|iPod/.test(_ua) && !window.MSStream;
  const _isMac = /Macintosh/.test(_ua) && !_isIOS;
  const _isAndroid = /Android/.test(_ua);
  const _isSafari = /Safari/.test(_ua) && !/Chrome|Chromium|Edg/.test(_ua);
  const _isAppleDevice = _isIOS || _isMac;
  const _isChromeDesktop = /Chrome/.test(_ua) && !/Android|Mobile/.test(_ua);

  let _walletObserver = null;
  function filterWallets(){
    // 2026-07-28 FINAL (Max): the Shopify wallet components own their internal
    // layout and resist external grid/flex placement, so we keep their natural
    // full-width stacked layout and only (1) hide the wallet this device
    // cannot use and (2) heal any leftover wrapper experiments.
    const root = document.querySelector('shopify-accelerated-checkout-cart');
    if (!root) return;
    for (const slot of Array.from(root.querySelectorAll(':scope > .mv-wallet-slot'))) {
      while (slot.firstChild) root.insertBefore(slot.firstChild, slot);
      slot.remove();
    }
    root.style.removeProperty('display');
    root.style.removeProperty('grid-template-columns');
    root.style.removeProperty('gap');
    const appleDevice = _isIOS || (_isMac && _isSafari);
    for (const el of Array.from(root.children)) {
      const tag = el.tagName.toLowerCase();
      const shouldHide = (appleDevice && tag.includes('google-pay')) || (!appleDevice && tag.includes('apple-pay'));
      const cur = el.style.getPropertyValue('display');
      if (shouldHide && cur !== 'none') el.style.setProperty('display', 'none', 'important');
      if (!shouldHide) {
        if (cur === 'none') el.style.removeProperty('display');
        for (const p of ['grid-row','grid-column','grid-area','min-width','width','max-width','order','flex']) el.style.removeProperty(p);
      }
    }
    if (!_walletObserver) {
      _walletObserver = new MutationObserver(() => {
        clearTimeout(_walletObserver._t);
        _walletObserver._t = setTimeout(filterWallets, 200);
      });
      _walletObserver.observe(root, { childList: true, subtree: false });
    }
  }

  async function fetchCart(){const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});if(!r.ok)throw new Error('cart-fetch-failed');return r.json();}
  async function addItem(vId,qty,plan,props){_inflight++;try{const body={id:vId,quantity:qty||1};if(plan)body.selling_plan=plan;if(props)body.properties=props;const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});if(!r.ok){const m=await r.text();throw new Error('add-failed:'+m.slice(0,200));}const item=await r.json();trackATC(item);return item;}finally{_inflight--;}}

  // Klaviyo "Added to Cart" — fire-and-forget, never blocks the cart flow
  function trackATC(item){
    try {
      const k = (window.klaviyo = window.klaviyo || []);
      fetchCart().then((cart) => {
        k.push(['track', 'Added to Cart', {
          $value: cart.total_price / 100,
          AddedItemProductName: item.product_title,
          AddedItemProductID: item.product_id,
          AddedItemSKU: item.sku,
          AddedItemPrice: item.price / 100,
          AddedItemQuantity: item.quantity,
          AddedItemURL: window.location.origin + (item.url || ''),
          AddedItemImageURL: item.image || '',
          ItemNames: cart.items.map((i) => i.product_title),
          CheckoutURL: window.location.origin + '/checkout',
          Items: cart.items.map((i) => ({
            ProductID: i.product_id,
            SKU: i.sku,
            ProductName: i.product_title,
            Quantity: i.quantity,
            ItemPrice: i.price / 100,
            RowTotal: i.line_price / 100,
            ProductURL: window.location.origin + (i.url || ''),
            ImageURL: i.image || ''
          }))
        }]);
      }).catch(() => {});
    } catch (e) { /* tracking must never break add-to-cart */ }
  }
  async function changeLine(key,upd){_inflight++;try{const body=Object.assign({id:key},upd);const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});if(!r.ok)throw new Error('change-failed');return await r.json();}finally{_inflight--;}}
  async function applyDiscount(code){
    const r=await fetch('/discount/'+encodeURIComponent(code),{redirect:'manual'});
    return r;
  }

  function open(){if(!elRoot)return;state.open=true;elRoot.setAttribute('open','');elRoot.setAttribute('aria-hidden','false');elRoot.removeAttribute('inert');elBackdrop.setAttribute('open','');document.body.style.overflow='hidden';document.dispatchEvent(new CustomEvent('minvelle:cart:open'));ensureExpressCheckout();}

  let _expressLoaded = false;
  let _expressLoading = null;
  async function ensureExpressCheckout(){
    const wrap = elRoot && elRoot.querySelector('[data-express-wallets]');
    const label = elRoot && elRoot.querySelector('[data-express-label]');
    if (!wrap) return;
    if (_expressLoaded) return;
    if (_expressLoading) return _expressLoading;
    _expressLoading = (async () => {
      try {
        const r = await fetch('/cart', { credentials: 'same-origin' });
        if (!r.ok) throw new Error('cart-fetch-' + r.status);
        const html = await r.text();
        const m = html.match(/<shopify-accelerated-checkout-cart[^>]*>[\s\S]*?<\/shopify-accelerated-checkout-cart>/);
        if (!m) throw new Error('component-not-found');
        wrap.innerHTML = m[0];
        if (label) label.hidden = false;
        if (label) label.removeAttribute('hidden');
        await new Promise(res => setTimeout(res, 50));
        if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
          window.Shopify.PaymentButton.init();
        }
        _expressLoaded = true;
        setTimeout(filterWallets, 600);
        setTimeout(filterWallets, 1500);
      } catch (e) {
        console.warn('[MinvelleCart] express checkout load failed', e);
        if (label) label.hidden = true;
        wrap.innerHTML = '';
      } finally {
        _expressLoading = null;
      }
    })();
    return _expressLoading;
  }
  function close(){if(!elRoot)return;state.open=false;elRoot.removeAttribute('open');elRoot.setAttribute('aria-hidden','true');elRoot.setAttribute('inert','');elBackdrop.removeAttribute('open');document.body.style.overflow='';document.dispatchEvent(new CustomEvent('minvelle:cart:close'));}
  function showToast(msg){const tt=elRoot.querySelector('.minvelle-cart__toast');if(!tt)return;tt.textContent=msg;tt.setAttribute('visible','');setTimeout(()=>tt.removeAttribute('visible'),4000);}

  async function refresh(){try{state.cart=await fetchCart();render();}catch(e){console.error('[MinvelleCart] refresh failed',e);showToast(t('cart.minvelle.error_refresh'));}}

  // 2026-11-04 WELCOMEBOX "Draufgabe" (Max): Shopify's Buy X Get Y never adds the free box itself, so with the code
  // on the cart (or in the discount_code cookie) and an eligible one-time box, add 1 x 1 Box; Shopify then splits it
  // into its own line at 0.00. The added line carries the hidden property _mv_freebox, and if no 1 Box line ends up
  // free (code not applicable, the 2-box switched to the subscription, the paid box removed) that line is taken out
  // again, so nobody pays for a box they never chose. Removing/decrementing a 1 Box line while a free one exists =
  // declined for this session (sessionStorage), never re-added. Guards: one try per cart token per 10 s, nothing
  // while a cart add/change is in flight, after one take-out no further tries on that token. Any failure: cart as is.
  const FREEBOX_CODE = 'WELCOMEBOX';
  const FREEBOX_ELIGIBLE = [VARIANT_1BOX, VARIANT_2BOX, VARIANT_4BOX, VARIANT_6BOX];
  const FREEBOX_DECLINED_KEY = 'mv_freebox_declined';
  let _inflight = 0, _fbBusy = false;
  const ss = (k, v) => { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } };
  const isFreeLine = (i) => i.variant_id === VARIANT_1BOX && !i.selling_plan_allocation && (i.final_line_price === 0 ||
    (i.line_level_discount_allocations || []).reduce((s, d) => s + d.amount, 0) >= i.original_line_price);
  const hasFreeBox = (cart) => !!(cart && cart.items && cart.items.some(isFreeLine));
  const isWelcomeFree = (i) => isFreeLine(i) && (i.line_level_discount_allocations || []).some((d) => d.amount > 0 && d.discount_application && String(d.discount_application.title).toUpperCase() === FREEBOX_CODE);
  function markDeclined(cart, variantId){ if (variantId === VARIANT_1BOX && hasFreeBox(cart)) ss(FREEBOX_DECLINED_KEY, '1'); }
  async function ensureFreeBox(cart){
    try {
      if (!cart || !cart.items || _fbBusy || _inflight) return;
      const code = (cart.discount_codes || []).some((d) => String(d.code).toUpperCase() === FREEBOX_CODE) || document.cookie.indexOf('discount_code=' + FREEBOX_CODE) !== -1;
      if (!code || ss(FREEBOX_DECLINED_KEY)) return;
      const ours = cart.items.find((i) => i.properties && i.properties._mv_freebox);
      const eligible = cart.items.some((i) => FREEBOX_ELIGIBLE.includes(i.variant_id) && !i.selling_plan_allocation && !(i.properties && i.properties._mv_freebox));
      const take = ours && !hasFreeBox(cart);         // our box is no longer free: take it out again
      const add = !ours && eligible && !hasFreeBox(cart);
      if (!take && !add) return;
      const tok = cart.token || '', last = (ss('mv_freebox_last') || '').split('|');
      if (add && (ss('mv_freebox_off') === tok || (last[0] === tok && Date.now() - (+last[1] || 0) < 10000))) return; // no ping-pong
      if (add) ss('mv_freebox_last', tok + '|' + Date.now());
      _fbBusy = true;
      if (take) { await changeLine(ours.key, {quantity: 0}); ss('mv_freebox_off', tok); }
      else {
        const r = await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({id: VARIANT_1BOX, quantity: 1, properties: {_mv_freebox: '1'}})}); // ponytail: no trackATC, the customer did not add it
        if (!r.ok) throw new Error('freebox-add-failed');
      }
      _fbBusy = false;
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; } // the /cart page is server-rendered (Dawn)
      await refresh(); // re-renders; a box that did not turn free gets taken out on this pass
    } catch (e) { _fbBusy = false; console.warn('[MinvelleCart] free box', e); }
  }
  // /cart page (Dawn rows, not this drawer): minus / remove / lowered input on a 1 Box row = declined
  function bindCartPageDecline(){
    const rowVariant = (el) => { const row = el.closest('.cart-item, tr'); const q = row && row.querySelector('[data-quantity-variant-id]'); return q ? parseInt(q.dataset.quantityVariantId, 10) : 0; };
    document.addEventListener('click', (e) => { const b = e.target.closest('cart-remove-button, .quantity__button[name="minus"]'); if (b) markDeclined(state.cart, rowVariant(b)); }, true);
    document.addEventListener('change', (e) => { const q = e.target.closest('.quantity__input[data-quantity-variant-id]'); if (q && parseInt(q.value, 10) < parseInt(q.defaultValue, 10)) markDeclined(state.cart, rowVariant(q)); }, true);
  }

  function deliveryRange() {
    const start = new Date();
    start.setDate(start.getDate() + 5);
    const end = new Date();
    end.setDate(end.getDate() + 9);
    const opts = { weekday: 'short', month: 'short', day: 'numeric' };
    const lang = (document.documentElement.lang || 'en').slice(0,2);
    const localeTag = mvLocale();
    return t('cart.minvelle.delivery_html')
      .replace('{start}', start.toLocaleDateString(localeTag, opts))
      .replace('{end}', end.toLocaleDateString(localeTag, opts));
  }

  function render(){
    const body = elRoot.querySelector('[data-cart-body]');
    const footer = elRoot.querySelector('[data-cart-footer]');
    const stickyCta = elRoot.querySelector('[data-sticky-cta]');
    if (!state.cart) return;
    ensureFreeBox(state.cart); // 2026-11-04 WELCOMEBOX free box: every refresh / change / add lands here
    setCurrency(state.cart.currency);
    updateCartIcon();
    body.innerHTML = '';

    renderShippingBar(state.cart);
    renderSavingsBadge(state.cart);

    if (!state.cart.items || state.cart.items.length === 0) {
      body.innerHTML = '<div class="minvelle-cart__empty">' +
        '<h3>' + t('cart.minvelle.empty_title') + '</h3>' +
        '<p>' + t('cart.minvelle.empty_body') + '</p>' +
        '<a class="button" href="/pages/minvelle-remineralizing-gum">' + t('cart.minvelle.empty_cta') + '</a>' +
      '</div>';
      footer.hidden = true;
      if (stickyCta) stickyCta.hidden = true;
      return;
    }
    footer.hidden = false;
    if (stickyCta) stickyCta.hidden = false;

    state.cart.items.forEach((item) => body.appendChild(renderLine(item)));

    const promos = elRoot.querySelector('[data-cart-promos]');
    if (promos) {
      promos.innerHTML = '';
      buildPromos(state.cart).forEach((n) => promos.appendChild(n));
    }

    // Total from the same per-line field the lines render (item.final_line_price) so lines and the
    // checkout total always sum. /cart.js aggregate items_subtotal_price can sit in a different basis
    // than final_line_price in non-EUR Markets sessions (line shows presentment, aggregate doesn't).
    // EUR: identical — no cart-level discount ever reaches the drawer (codes apply via /discount
    // redirect at checkout, cart is never re-fetched with them). ponytail: reduce, no lib.
    const subtotal = state.cart.items.reduce((s, i) => s + i.final_line_price, 0);
    const sc = shipConsts(state.cart.currency);
    const shipping = sc && subtotal < sc.threshold ? sc.cost : 0;
    const total = subtotal + shipping;

    elRoot.querySelector('[data-checkout-total]').textContent = '· ' + fmtMoney(total);

    const deliveryEl = elRoot.querySelector('[data-delivery-text]');
    if (deliveryEl) deliveryEl.innerHTML = deliveryRange();
  }

  // mix & match: show visible line item properties ("Box 1" = "Mastic Mint"); keys starting with _ stay hidden
  // flavour thumbs live next to this file in the theme assets folder (same CDN path), so no Liquid is needed
  const ASSET_BASE=((document.currentScript&&document.currentScript.src)||'').replace(/minvelle-cart\.js.*$/,'');
  const FLAVOUR_IMG={'Mastic Mint':'flavour-mint.png','Calm Matcha':'flavour-matcha.png','Warm Cinnamon':'flavour-cinnamon.png'};
  function flavourLines(item){const p=item.properties||{};const ks=Object.keys(p).filter(k=>k[0]!=='_'&&p[k]);if(!ks.length)return '';const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));return '<span class="minvelle-cart__line-variant" style="display:block;font-size:12px;line-height:1.45">'+ks.map(k=>{const f=FLAVOUR_IMG[p[k]];return '<span style="display:flex;align-items:center;gap:6px;margin:2px 0">'+(f&&ASSET_BASE?'<img src="'+ASSET_BASE+f+'" alt="" width="18" height="18" loading="lazy" style="width:18px;height:18px;border-radius:4px;flex:0 0 auto">':'')+esc(k)+': '+esc(p[k])+'</span>';}).join('')+'</span>';}
  function renderLine(item){
    const div=document.createElement('div');div.className='minvelle-cart__line';div.dataset.lineKey=item.key;
    const isSub=!!item.selling_plan_allocation;
    const img=item.image||(item.featured_image&&item.featured_image.url)||'';
    const compareCents=item.original_line_price && item.original_line_price>item.final_line_price ? item.original_line_price : null;
    div.innerHTML =
      '<img class="minvelle-cart__line-img" src="'+img+'" alt="'+(item.product_title||'')+'">'+
      '<div class="minvelle-cart__line-meta">'+
        '<span class="minvelle-cart__line-title">'+(item.product_title || '').replace(/Remineralizing\s*/i,'')+'</span>'+
        '<span class="minvelle-cart__line-variant">'+(item.variant_title||'')+'</span>'+
        (isWelcomeFree(item)?'<span class="minvelle-cart__line-variant">Free box · WELCOMEBOX</span>':'')+ // 2026-11-04, existing class, no new CSS
        flavourLines(item)+(isSub?'<span class="minvelle-cart__line-sub-badge"><span style="margin-right:5px">🔁</span>'+t('cart.minvelle.sub_badge')+'</span>'+(window.MinvelleCartStrings&&window.MinvelleCartStrings['cart.minvelle.sub_line']?'<span class="minvelle-cart__line-sub-note" style="display:block;margin-top:4px;font-size:12px;line-height:1.35;color:inherit;opacity:.72">'+t('cart.minvelle.sub_line')+'</span>':''):'')+
        '<div class="minvelle-cart__line-qty">'+
          '<button type="button" data-qty-dec aria-label="'+t('cart.minvelle.qty_decrease')+'">−</button>'+
          '<span>'+item.quantity+'</span>'+
          '<button type="button" data-qty-inc aria-label="'+t('cart.minvelle.qty_increase')+'">+</button>'+
        '</div>'+
      '</div>'+
      '<div class="minvelle-cart__line-right">'+
        '<span class="minvelle-cart__line-price">'+fmtMoney(item.final_line_price)+'</span>'+
        (compareCents?'<span class="minvelle-cart__line-compare">'+fmtMoney(compareCents)+'</span>':'')+
        '<button type="button" data-line-remove>'+t('cart.minvelle.remove')+'</button>'+
      '</div>';
    div.querySelector('[data-qty-dec]').addEventListener('click',()=>updateQty(item.key,Math.max(0,item.quantity-1)));
    div.querySelector('[data-qty-inc]').addEventListener('click',()=>updateQty(item.key,item.quantity+1));
    div.querySelector('[data-line-remove]').addEventListener('click',()=>updateQty(item.key,0));
    return div;
  }

  async function updateQty(key,qty){try{const ln=state.cart&&state.cart.items.find(i=>i.key===key);if(ln&&qty<ln.quantity)markDeclined(state.cart,ln.variant_id);}catch(e){} // 2026-11-04 free box declined
    try{state.cart=await changeLine(key,{quantity:qty});render();}catch(e){console.error('[MinvelleCart] updateQty failed',e);showToast(t('cart.minvelle.error_refresh'));}}

  function renderShippingBar(cart){
    const subtotal=cart.items_subtotal_price;
    const bar=elRoot.querySelector('[data-shipping-bar]');
    const fill=elRoot.querySelector('[data-shipping-fill]');
    const label=elRoot.querySelector('[data-shipping-label]');
    const amount=elRoot.querySelector('[data-shipping-amount]');
    const sc=shipConsts(cart.currency);
    if(!sc){bar.hidden=true;return;}
    bar.hidden=false;
    if(subtotal>=sc.threshold){
      bar.classList.add('minvelle-cart__shipping--unlocked');
      label.innerHTML='🎉 <strong>'+t('cart.minvelle.shipping_unlocked')+'</strong>';
      amount.textContent='';
      fill.style.width='100%';
    } else {
      bar.classList.remove('minvelle-cart__shipping--unlocked');
      const remaining = sc.displayThreshold - subtotal;
      label.innerHTML = t('cart.minvelle.shipping_progress_label_html')
        .replace('{current}', fmtMoney(subtotal))
        .replace('{target}', fmtMoney(sc.displayThreshold));
      amount.innerHTML = t('cart.minvelle.shipping_progress_remaining_html').replace('{amount}', fmtMoney(remaining));
      const pct = Math.min(100, Math.max(4, (subtotal / sc.threshold) * 100));
      fill.style.width = pct + '%';
    }
  }

  // Savings badge: compare-at baseline minus what the cart actually costs. Compare-at comes from
  // the product .js endpoint (cached per handle), so bundle, subscription and discount-code savings
  // land in one number and no price is hardcoded here.
  const comparePrices = {};
  const variantPrices = {}; // presentment prices from /products/<handle>.js, used by the 2 to 4 upsell
  const compareFetched = {};
  function ensureComparePrices(cart){
    // compareFetched holds the in-flight promise per handle, so a second caller waits for the same fetch
    // instead of getting an instantly resolved empty promise (the 2 to 4 upsell relies on this).
    const handles = [...new Set(cart.items.map((i) => i.handle).filter(Boolean))];
    if (!handles.length) return Promise.resolve();
    return Promise.all(handles.map((h) => {
      if (compareFetched[h]) return compareFetched[h];
      return compareFetched[h] = fetch('/products/' + h + '.js', {headers:{Accept:'application/json'}})
        .then((r) => r.ok ? r.json() : null)
        .then((p) => { if (p && p.variants) p.variants.forEach((v) => { variantPrices[v.id] = v.price; if (v.compare_at_price) comparePrices[v.id] = v.compare_at_price; }); })
        .catch(() => {});
    }));
  }
  function renderSavingsBadge(cart){
    const badge = elRoot.querySelector('[data-savings-badge]');
    const label = elRoot.querySelector('[data-savings-label]');
    if (!badge || !label) return;
    const apply = () => {
      let baseline = 0;
      cart.items.forEach((i) => { baseline += (comparePrices[i.variant_id] || i.price) * i.quantity; });
      const savings = baseline - cart.total_price;
      if (savings > 0 && cart.items.length) {
        label.innerHTML = t('cart.minvelle.savings_html').replace('{amount}', fmtMoney(savings));
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    };
    apply();
    ensureComparePrices(cart).then(() => { if (state.cart === cart) apply(); });
  }

  // Subscription-first upsell hierarchy (2026-07-02). States:
  //   sub line present  -> confirmation chip only, zero competing upsells
  //   2-box one-time    -> HERO subscription switch card (+ secondary 4-pack text link if sole line)
  //   1-box one-time    -> HERO card to 2-box subscription (+ secondary 2-box one-time text link)
  //   4-box one-time    -> secondary 6-pack text link if sole line
  //   6-box / other     -> nothing
  const BOXES_BY_VARIANT={[VARIANT_1BOX]:1,[VARIANT_2BOX]:2,[VARIANT_4BOX]:4,[VARIANT_6BOX]:6};
  // mix & match: carry the flavour picks into the bigger tier, added boxes default to Mastic Mint
  function carryFlavours(item, variantId){const p=item.properties||{};if(!p['Box 1'])return null;const n=BOXES_BY_VARIANT[variantId]||0;const out={};for(let i=1;i<=n;i++)out['Box '+i]=p['Box '+i]||'Mastic Mint';return out;}
  async function swapLine(item, variantId, plan){
    await changeLine(item.key, {quantity: 0});
    await addItem(variantId, 1, plan || null, carryFlavours(item, variantId));
    await refresh();
  }
  function promoButton(btn, action){
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      try { await action(); }
      catch (e) { console.error('[MinvelleCart] upsell action', e); btn.disabled = false; showToast(t('cart.minvelle.error_refresh')); }
    });
  }
  function heroCard(title, sub, cta, action){
    const div=document.createElement('div');div.className='minvelle-cart__hero';
    div.innerHTML='<div class="minvelle-cart__hero-title"><span style="margin-right:7px">🔁</span>'+title+'</div>'+
      '<div class="minvelle-cart__hero-sub">'+sub+'</div>'+
      '<button type="button" class="minvelle-cart__hero-cta">'+cta+'</button>';
    promoButton(div.querySelector('button'), action);
    return div;
  }
  function linkCard(label, action){
    const div=document.createElement('div');div.className='minvelle-cart__secondary';
    div.innerHTML='<button type="button" class="minvelle-cart__secondary-link">'+label+'</button>';
    promoButton(div.querySelector('button'), action);
    return div;
  }
  // Cart upsell 2 to 4 (W43). Flag + EN strings live in snippets/minvelle-cart-drawer.liquid. Returns null whenever
  // the block must not show, so buildPromos falls back to the plain text link. Prices are the live presentment
  // prices (cart line + products.js), never literals, so Markets sessions get their own currency.
  const UP4_DISMISS_KEY = 'mv_cart_up4_no';
  function upsell4Card(cart, twoBox){
    if (window.MV_CART_UPSELL !== true && window.MV_CART_UPSELL_FORCE !== true) return null;
    const S = (window.MV_CART_UPSELL_STRINGS || {})[(document.documentElement.lang || 'en').slice(0, 2)];
    if (!S) return null;
    if (twoBox.selling_plan_allocation || twoBox.quantity !== 1) return null;
    if (cart.items.some((it) => it.variant_id === VARIANT_4BOX)) return null;
    try { if (sessionStorage.getItem(UP4_DISMISS_KEY) === '1') return null; } catch (e) {}
    const p4 = variantPrices[VARIANT_4BOX];
    if (!p4) { // price not fetched yet: fetch once, re-render only if it arrived (no loop on a failed fetch)
      ensureComparePrices(cart).then(() => { if (state.cart === cart && variantPrices[VARIANT_4BOX]) render(); });
      return null;
    }
    const saved = 2 * twoBox.price - p4;
    if (saved <= 0) return null;
    const div = document.createElement('div'); div.className = 'minvelle-cart__up4';
    div.innerHTML = '<button type="button" class="minvelle-cart__up4-cta">' + S.cta.replace('{price}', fmtMoney(p4)) + '</button>' +
      '<p class="minvelle-cart__up4-sub">' + S.sub.replace('{amount}', fmtMoney(saved)) + '</p>' +
      '<button type="button" class="minvelle-cart__up4-no">' + S.dismiss + '</button>';
    promoButton(div.querySelector('.minvelle-cart__up4-cta'), () => swapLine(twoBox, VARIANT_4BOX));
    div.querySelector('.minvelle-cart__up4-no').addEventListener('click', () => {
      try { sessionStorage.setItem(UP4_DISMISS_KEY, '1'); } catch (e) {}
      render();
    });
    return div;
  }
  function buildPromos(cart){
    const out=[];
    if(!cart.items || cart.items.length===0) return out;
    if(cart.items.some(it=>!!it.selling_plan_allocation)){
      const chip=document.createElement('div');chip.className='minvelle-cart__sub-chip';
      chip.innerHTML=t('cart.minvelle.sub_locked_chip');
      out.push(chip);
      return out;
    }
    const single = cart.items.length===1 ? cart.items[0] : null;
    const twoBox = cart.items.find(it=>it.variant_id===VARIANT_2BOX);
    if(twoBox){
      out.push(heroCard(t('cart.minvelle.sub_hero_title'), t('cart.minvelle.sub_hero_sub'), t('cart.minvelle.sub_hero_cta'), async ()=>{
        try { state.cart = await changeLine(twoBox.key, {selling_plan: SUB_PLAN_ID}); render(); }
        catch (e) { await swapLine(twoBox, VARIANT_2BOX, SUB_PLAN_ID); } // fallback: remove + re-add with plan
      }));
      // mv 2026-09-25: only upsell a single line, 2x2 is already 4 boxes
      const up4 = upsell4Card(cart, twoBox);
      if(up4) out.push(up4);
      else if(single && twoBox.quantity===1) out.push(linkCard(t('cart.minvelle.upsell_2to4_link'), ()=>swapLine(twoBox, VARIANT_4BOX)));
      return out;
    }
    if(single && single.variant_id===VARIANT_1BOX){
      // §3 nudge: only for a lone single 1-box (qty 1), where free shipping over €29 is genuinely still ahead
      if(single.quantity===1){
        const nudge=document.createElement('div');
        nudge.className='minvelle-cart__nudge';
        nudge.setAttribute('style','margin:0 0 4px;padding:10px 12px;border-radius:10px;background:#EAF9F3;border:1px solid #DCF1E8;color:#0A7F7F;font-size:12.5px;font-weight:600;line-height:1.45;');
        nudge.textContent=t('cart.minvelle.nudge_add2nd_html');
        out.push(nudge);
      }
      out.push(heroCard(t('cart.minvelle.sub_hero_title'), t('cart.minvelle.sub_hero_1box_sub'), t('cart.minvelle.sub_panel_cta'), ()=>swapLine(single, VARIANT_2BOX, SUB_PLAN_ID)));
      out.push(linkCard(t('cart.minvelle.upsell_add2nd_link'), ()=>swapLine(single, VARIANT_2BOX)));
      return out;
    }
    const fourBox = cart.items.find(it=>it.variant_id===VARIANT_4BOX);
    if(single && fourBox && fourBox.quantity===1){ // mv 2026-09-25: only upsell a single line, 2x2 is already 4 boxes
      out.push(linkCard(t('cart.minvelle.upsell_4to6_link'), ()=>swapLine(fourBox, VARIANT_6BOX)));
    }
    return out;
  }

  function bindDiscount(){
    const discountWrap = elRoot.querySelector('[data-discount]');
    const toggle = elRoot.querySelector('[data-discount-toggle]');
    const panel = elRoot.querySelector('[data-discount-panel]');
    const input = elRoot.querySelector('[data-discount-input]');
    const apply = elRoot.querySelector('[data-discount-apply]');
    const msg = elRoot.querySelector('[data-discount-msg]');
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      const open = !panel.hidden;
      panel.hidden = open;
      if (open) discountWrap.removeAttribute('open');
      else { discountWrap.setAttribute('open',''); input.focus(); }
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); apply.click(); }
    });
    apply.addEventListener('click', async () => {
      const code = (input.value || '').trim().toUpperCase();
      if (!code || apply.disabled) return;
      apply.disabled = true;
      try {
        await applyDiscount(code);
        msg.textContent = t('cart.minvelle.discount_applied_html').replace('{code}', code);
        msg.classList.remove('minvelle-cart__discount-msg--err');
        msg.classList.add('minvelle-cart__discount-msg--ok');
        msg.hidden = false;
      } catch (e) {
        msg.textContent = t('cart.minvelle.discount_invalid');
        msg.classList.remove('minvelle-cart__discount-msg--ok');
        msg.classList.add('minvelle-cart__discount-msg--err');
        msg.hidden = false;
      }
      apply.disabled = false;
    });
  }

  function bindAddToCartHooks(){
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-add-to-cart]');
      if (btn) {
        e.preventDefault();
        const vId = parseInt(btn.dataset.variantId, 10);
        const qty = parseInt(btn.dataset.quantity || '1', 10);
        const plan = btn.dataset.sellingPlanId ? parseInt(btn.dataset.sellingPlanId, 10) : null;
        if (!vId) return;
        try { await addItem(vId, qty, plan); await refresh(); open(); }
        catch (err) { console.error(err); showToast(t('cart.minvelle.error_add')); }
        return;
      }
      const a = e.target.closest('a[href^="/cart/"]');
      if (a) {
        const m = a.getAttribute('href').match(/^\/cart\/(\d+):(\d+)/);
        if (m) {
          e.preventDefault();
          try { await addItem(parseInt(m[1],10), parseInt(m[2],10)); await refresh(); open(); }
          catch (err) { console.error(err); showToast(t('cart.minvelle.error_add')); }
        }
      }
    });
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      const fd = new FormData(form);
      try { const r = await fetch('/cart/add.js', { method: 'POST', body: fd }); if (!r.ok) throw new Error('add-form-failed'); trackATC(await r.json()); await refresh(); open(); }
      catch (err) { console.error(err); showToast(t('cart.minvelle.error_add')); }
    });
  }

  function bindDrawerControls(){
    elRoot.querySelector('.minvelle-cart__close').addEventListener('click', close);
    elBackdrop.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && state.open) close(); });
    document.addEventListener('click', (e) => { const toggle = e.target.closest('[data-cart-toggle]'); if (toggle) { e.preventDefault(); refresh().then(open); } });
  }

  // Header cart icon: no template renders a cart link, so inject one next to the nav CTA (fixed pill as fallback)
  function injectCartIcon(){
    if (document.querySelector('.minvelle-cart-trigger')) return;
    const a=document.createElement('a');
    a.href='/cart';
    a.setAttribute('data-cart-toggle','');
    a.className='minvelle-cart-trigger';
    a.setAttribute('aria-label',(document.documentElement.lang||'').slice(0,2)==='de'?'Warenkorb':'Cart');
    a.innerHTML='<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 4h2l2.4 12.2A2 2 0 0 0 9.36 18h8.34a2 2 0 0 0 1.96-1.6L21.5 8H6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="10" cy="20.6" r="1.4" fill="currentColor" stroke="none"/><circle cx="17.6" cy="20.6" r="1.4" fill="currentColor" stroke="none"/></svg><span class="minvelle-cart-trigger__count" hidden></span>';
    const cta=document.querySelector('.mv-nav .mv-shop-cta, nav .nav-cta, nav .mv-shop-cta, nav .mvtp-shop-cta');
    if (cta && cta.parentNode) cta.parentNode.insertBefore(a, cta);
    else { a.classList.add('minvelle-cart-trigger--fixed'); document.body.appendChild(a); }
  }
  function updateCartIcon(){
    const b=document.querySelector('.minvelle-cart-trigger__count');
    if(!b)return;
    const n=(state.cart&&state.cart.item_count)||0;
    b.textContent=n>99?'99+':String(n);
    b.hidden=n===0;
  }

  function bindCheckoutOnce(){const btn=elRoot.querySelector('[data-cart-checkout]');if(btn&&!btn._bound){btn._bound=true;btn.addEventListener('click',()=>{window.location.href='/checkout';});}}

  function boot(){
    convertTagged();
    elRoot = document.querySelector('.minvelle-cart');
    elBackdrop = document.querySelector('.minvelle-cart__backdrop');
    if (!elRoot || !elBackdrop) { console.warn('[MinvelleCart] drawer markup not found'); return; }
    bindDrawerControls();
    bindAddToCartHooks();
    bindDiscount();
    injectCartIcon();
    bindCartPageDecline();
    refresh().then(bindCheckoutOnce);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.MinvelleCart = { open, close, refresh, addItem, state, filterWallets };
})();
